/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CompatibilityRouteImport } from './routes/compatibility'
import { Route as ConfiguratorRouteImport } from './routes/configurator'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as UiKitRouteImport } from './routes/ui-kit'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as CategoriesCategoryIdRouteImport } from './routes/categories_.$categoryId'
import { Route as CategoryIdRouteImport } from './routes/category.$id'
import { Route as ProductIdRouteImport } from './routes/product.$id'
import { Route as ProductsIdRouteImport } from './routes/products_.$id'
import { Route as SolutionSlugRouteImport } from './routes/solution.$slug'
import { Route as SolutionsSlugRouteImport } from './routes/solutions_.$slug'
import { Route as SubcategoryIdRouteImport } from './routes/subcategory.$id'
import { Route as CategoriesCategoryIdIndexRouteImport } from './routes/categories_.$categoryId.index'
import { Route as CategoriesCategoryIdSubcategoryIdRouteImport } from './routes/categories_.$categoryId.$subcategoryId'
import { Route as CategoriesCategoryIdSubcategoriesSubcategoryIdRouteImport } from './routes/categories_.$categoryId.subcategories.$subcategoryId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const CompatibilityRoute = CompatibilityRouteImport.update({
  id: '/compatibility',
  path: '/compatibility',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguratorRoute = ConfiguratorRouteImport.update({
  id: '/configurator',
  path: '/configurator',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsRoute = SolutionsRouteImport.update({
  id: '/solutions',
  path: '/solutions',
  getParentRoute: () => rootRouteImport,
} as any)
const UiKitRoute = UiKitRouteImport.update({
  id: '/ui-kit',
  path: '/ui-kit',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog_/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesCategoryIdRoute = CategoriesCategoryIdRouteImport.update({
  id: '/categories_/$categoryId',
  path: '/categories/$categoryId',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoryIdRoute = CategoryIdRouteImport.update({
  id: '/category/$id',
  path: '/category/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductIdRoute = ProductIdRouteImport.update({
  id: '/product/$id',
  path: '/product/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIdRoute = ProductsIdRouteImport.update({
  id: '/products_/$id',
  path: '/products/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionSlugRoute = SolutionSlugRouteImport.update({
  id: '/solution/$slug',
  path: '/solution/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsSlugRoute = SolutionsSlugRouteImport.update({
  id: '/solutions_/$slug',
  path: '/solutions/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SubcategoryIdRoute = SubcategoryIdRouteImport.update({
  id: '/subcategory/$id',
  path: '/subcategory/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesCategoryIdIndexRoute =
  CategoriesCategoryIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CategoriesCategoryIdRoute,
  } as any)
const CategoriesCategoryIdSubcategoryIdRoute =
  CategoriesCategoryIdSubcategoryIdRouteImport.update({
    id: '/$subcategoryId',
    path: '/$subcategoryId',
    getParentRoute: () => CategoriesCategoryIdRoute,
  } as any)
const CategoriesCategoryIdSubcategoriesSubcategoryIdRoute =
  CategoriesCategoryIdSubcategoriesSubcategoryIdRouteImport.update({
    id: '/subcategories/$subcategoryId',
    path: '/subcategories/$subcategoryId',
    getParentRoute: () => CategoriesCategoryIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blog': typeof BlogRoute
  '/compatibility': typeof CompatibilityRoute
  '/configurator': typeof ConfiguratorRoute
  '/products': typeof ProductsRoute
  '/search': typeof SearchRoute
  '/solutions': typeof SolutionsRoute
  '/ui-kit': typeof UiKitRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRouteWithChildren
  '/category/$id': typeof CategoryIdRoute
  '/product/$id': typeof ProductIdRoute
  '/products/$id': typeof ProductsIdRoute
  '/solution/$slug': typeof SolutionSlugRoute
  '/solutions/$slug': typeof SolutionsSlugRoute
  '/subcategory/$id': typeof SubcategoryIdRoute
  '/categories/$categoryId/$subcategoryId': typeof CategoriesCategoryIdSubcategoryIdRoute
  '/categories/$categoryId/': typeof CategoriesCategoryIdIndexRoute
  '/categories/$categoryId/subcategories/$subcategoryId': typeof CategoriesCategoryIdSubcategoriesSubcategoryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blog': typeof BlogRoute
  '/compatibility': typeof CompatibilityRoute
  '/configurator': typeof ConfiguratorRoute
  '/products': typeof ProductsRoute
  '/search': typeof SearchRoute
  '/solutions': typeof SolutionsRoute
  '/ui-kit': typeof UiKitRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/category/$id': typeof CategoryIdRoute
  '/product/$id': typeof ProductIdRoute
  '/products/$id': typeof ProductsIdRoute
  '/solution/$slug': typeof SolutionSlugRoute
  '/solutions/$slug': typeof SolutionsSlugRoute
  '/subcategory/$id': typeof SubcategoryIdRoute
  '/categories/$categoryId/$subcategoryId': typeof CategoriesCategoryIdSubcategoryIdRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdIndexRoute
  '/categories/$categoryId/subcategories/$subcategoryId': typeof CategoriesCategoryIdSubcategoriesSubcategoryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blog': typeof BlogRoute
  '/compatibility': typeof CompatibilityRoute
  '/configurator': typeof ConfiguratorRoute
  '/products': typeof ProductsRoute
  '/search': typeof SearchRoute
  '/solutions': typeof SolutionsRoute
  '/ui-kit': typeof UiKitRoute
  '/blog_/$slug': typeof BlogSlugRoute
  '/categories_/$categoryId': typeof CategoriesCategoryIdRouteWithChildren
  '/category/$id': typeof CategoryIdRoute
  '/product/$id': typeof ProductIdRoute
  '/products_/$id': typeof ProductsIdRoute
  '/solution/$slug': typeof SolutionSlugRoute
  '/solutions_/$slug': typeof SolutionsSlugRoute
  '/subcategory/$id': typeof SubcategoryIdRoute
  '/categories_/$categoryId/$subcategoryId': typeof CategoriesCategoryIdSubcategoryIdRoute
  '/categories_/$categoryId/': typeof CategoriesCategoryIdIndexRoute
  '/categories_/$categoryId/subcategories/$subcategoryId': typeof CategoriesCategoryIdSubcategoriesSubcategoryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blog'
    | '/compatibility'
    | '/configurator'
    | '/products'
    | '/search'
    | '/solutions'
    | '/ui-kit'
    | '/blog/$slug'
    | '/categories/$categoryId'
    | '/category/$id'
    | '/product/$id'
    | '/products/$id'
    | '/solution/$slug'
    | '/solutions/$slug'
    | '/subcategory/$id'
    | '/categories/$categoryId/$subcategoryId'
    | '/categories/$categoryId/'
    | '/categories/$categoryId/subcategories/$subcategoryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blog'
    | '/compatibility'
    | '/configurator'
    | '/products'
    | '/search'
    | '/solutions'
    | '/ui-kit'
    | '/blog/$slug'
    | '/category/$id'
    | '/product/$id'
    | '/products/$id'
    | '/solution/$slug'
    | '/solutions/$slug'
    | '/subcategory/$id'
    | '/categories/$categoryId/$subcategoryId'
    | '/categories/$categoryId'
    | '/categories/$categoryId/subcategories/$subcategoryId'
  id:
    | '__root__'
    | '/'
    | '/blog'
    | '/compatibility'
    | '/configurator'
    | '/products'
    | '/search'
    | '/solutions'
    | '/ui-kit'
    | '/blog_/$slug'
    | '/categories_/$categoryId'
    | '/category/$id'
    | '/product/$id'
    | '/products_/$id'
    | '/solution/$slug'
    | '/solutions_/$slug'
    | '/subcategory/$id'
    | '/categories_/$categoryId/$subcategoryId'
    | '/categories_/$categoryId/'
    | '/categories_/$categoryId/subcategories/$subcategoryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlogRoute: typeof BlogRoute
  CompatibilityRoute: typeof CompatibilityRoute
  ConfiguratorRoute: typeof ConfiguratorRoute
  ProductsRoute: typeof ProductsRoute
  SearchRoute: typeof SearchRoute
  SolutionsRoute: typeof SolutionsRoute
  UiKitRoute: typeof UiKitRoute
  BlogSlugRoute: typeof BlogSlugRoute
  CategoriesCategoryIdRoute: typeof CategoriesCategoryIdRouteWithChildren
  CategoryIdRoute: typeof CategoryIdRoute
  ProductIdRoute: typeof ProductIdRoute
  ProductsIdRoute: typeof ProductsIdRoute
  SolutionSlugRoute: typeof SolutionSlugRoute
  SolutionsSlugRoute: typeof SolutionsSlugRoute
  SubcategoryIdRoute: typeof SubcategoryIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compatibility': {
      id: '/compatibility'
      path: '/compatibility'
      fullPath: '/compatibility'
      preLoaderRoute: typeof CompatibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configurator': {
      id: '/configurator'
      path: '/configurator'
      fullPath: '/configurator'
      preLoaderRoute: typeof ConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions': {
      id: '/solutions'
      path: '/solutions'
      fullPath: '/solutions'
      preLoaderRoute: typeof SolutionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui-kit': {
      id: '/ui-kit'
      path: '/ui-kit'
      fullPath: '/ui-kit'
      preLoaderRoute: typeof UiKitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog_/$slug': {
      id: '/blog_/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories_/$categoryId': {
      id: '/categories_/$categoryId'
      path: '/categories/$categoryId'
      fullPath: '/categories/$categoryId'
      preLoaderRoute: typeof CategoriesCategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/category/$id': {
      id: '/category/$id'
      path: '/category/$id'
      fullPath: '/category/$id'
      preLoaderRoute: typeof CategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/$id': {
      id: '/product/$id'
      path: '/product/$id'
      fullPath: '/product/$id'
      preLoaderRoute: typeof ProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products_/$id': {
      id: '/products_/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solution/$slug': {
      id: '/solution/$slug'
      path: '/solution/$slug'
      fullPath: '/solution/$slug'
      preLoaderRoute: typeof SolutionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions_/$slug': {
      id: '/solutions_/$slug'
      path: '/solutions/$slug'
      fullPath: '/solutions/$slug'
      preLoaderRoute: typeof SolutionsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subcategory/$id': {
      id: '/subcategory/$id'
      path: '/subcategory/$id'
      fullPath: '/subcategory/$id'
      preLoaderRoute: typeof SubcategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories_/$categoryId/': {
      id: '/categories_/$categoryId/'
      path: '/'
      fullPath: '/categories/$categoryId/'
      preLoaderRoute: typeof CategoriesCategoryIdIndexRouteImport
      parentRoute: typeof CategoriesCategoryIdRoute
    }
    '/categories_/$categoryId/$subcategoryId': {
      id: '/categories_/$categoryId/$subcategoryId'
      path: '/$subcategoryId'
      fullPath: '/categories/$categoryId/$subcategoryId'
      preLoaderRoute: typeof CategoriesCategoryIdSubcategoryIdRouteImport
      parentRoute: typeof CategoriesCategoryIdRoute
    }
    '/categories_/$categoryId/subcategories/$subcategoryId': {
      id: '/categories_/$categoryId/subcategories/$subcategoryId'
      path: '/subcategories/$subcategoryId'
      fullPath: '/categories/$categoryId/subcategories/$subcategoryId'
      preLoaderRoute: typeof CategoriesCategoryIdSubcategoriesSubcategoryIdRouteImport
      parentRoute: typeof CategoriesCategoryIdRoute
    }
  }
}

interface CategoriesCategoryIdRouteChildren {
  CategoriesCategoryIdSubcategoryIdRoute: typeof CategoriesCategoryIdSubcategoryIdRoute
  CategoriesCategoryIdIndexRoute: typeof CategoriesCategoryIdIndexRoute
  CategoriesCategoryIdSubcategoriesSubcategoryIdRoute: typeof CategoriesCategoryIdSubcategoriesSubcategoryIdRoute
}

const CategoriesCategoryIdRouteChildren: CategoriesCategoryIdRouteChildren = {
  CategoriesCategoryIdSubcategoryIdRoute:
    CategoriesCategoryIdSubcategoryIdRoute,
  CategoriesCategoryIdIndexRoute: CategoriesCategoryIdIndexRoute,
  CategoriesCategoryIdSubcategoriesSubcategoryIdRoute:
    CategoriesCategoryIdSubcategoriesSubcategoryIdRoute,
}

const CategoriesCategoryIdRouteWithChildren =
  CategoriesCategoryIdRoute._addFileChildren(CategoriesCategoryIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlogRoute: BlogRoute,
  CompatibilityRoute: CompatibilityRoute,
  ConfiguratorRoute: ConfiguratorRoute,
  ProductsRoute: ProductsRoute,
  SearchRoute: SearchRoute,
  SolutionsRoute: SolutionsRoute,
  UiKitRoute: UiKitRoute,
  BlogSlugRoute: BlogSlugRoute,
  CategoriesCategoryIdRoute: CategoriesCategoryIdRouteWithChildren,
  CategoryIdRoute: CategoryIdRoute,
  ProductIdRoute: ProductIdRoute,
  ProductsIdRoute: ProductsIdRoute,
  SolutionSlugRoute: SolutionSlugRoute,
  SolutionsSlugRoute: SolutionsSlugRoute,
  SubcategoryIdRoute: SubcategoryIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
